export default "__VITE_ASSET__DIyiTm3v__"